var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "head_title" } },
        [
          _c(
            "v-col",
            {
              staticClass: "pa-0",
              attrs: { cols: "12", id: "main_content_maxwidthset" },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: {
                    align: "center",
                    justify: "space-between",
                    id: "header_height",
                  },
                },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [_vm._v(_vm._s(_vm.ts("title")))]
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { align: "center", justify: "end" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 ml-2",
                          attrs: {
                            width: "9rem",
                            height: "auto",
                            id: "blue_btn",
                            elevation: "0",
                          },
                          on: { click: _vm.requestSave },
                        },
                        [_vm._v(" " + _vm._s(_vm.ts("save")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: {
            id: "main_content_maxwidthset",
            cols: "12",
            align: "center",
          },
        },
        [
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0 pt-9", attrs: { cols: "10" } },
            [
              _vm.authorities.SET_PERMISSIONS_GROUP
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 setting_btn",
                      attrs: { id: "setting_btn1", cols: "12" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0 back_clean_btn",
                          attrs: {
                            id: "back_clean_btn1",
                            width: "100%",
                            height: "auto",
                            elevation: "0",
                          },
                          on: { click: _vm.goAuthoritySetting },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-4",
                              attrs: {
                                align: "center",
                                justify: "space-between",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.ts("shareUserPermissionSettings")
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { align: "center", justify: "end" },
                                },
                                [
                                  _vm.role == "main" || _vm.role == "head"
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 pr-3",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ts("shareUserOfTheMainStore")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { cols: "auto" },
                                    },
                                    [
                                      _c("v-img", {
                                        staticClass: "ma-0 pa-0 ml-2 pr-2",
                                        attrs: {
                                          height: "1rem",
                                          width: "0.6rem",
                                          src: require("@/assets/images/right_btn.png"),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.authorities.SET_LOGOUT_TIME
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 setting_btn",
                      attrs: { id: "setting_btn5", cols: "12" },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-2 pl-4",
                          attrs: { align: "center", justify: "space-between" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s(_vm.ts("automaticLogoutOverTime")))]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "ma-0 pa-0", attrs: { cols: "2" } },
                            [
                              _c("v-select", {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  items: _vm.autoLogoutTimeList,
                                  dense: "",
                                  "hide-details": "",
                                  outlined: "",
                                  dark: "",
                                  "item-text": "label",
                                  "item-value": "value",
                                },
                                model: {
                                  value: _vm.selectedAutoLogoutTime,
                                  callback: function ($$v) {
                                    _vm.selectedAutoLogoutTime = $$v
                                  },
                                  expression: "selectedAutoLogoutTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.authorities.SET_LOGOUT_TIME
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 setting_btn",
                      attrs: { id: "setting_btn6", cols: "12" },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-2 pl-4",
                          attrs: { align: "center", justify: "space-between" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.ts("sessionTimeoutWhenInactive"))
                              ),
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "ma-0 pa-0", attrs: { cols: "2" } },
                            [
                              _c("v-select", {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  items: _vm.sessionTimeList,
                                  dense: "",
                                  "hide-details": "",
                                  outlined: "",
                                  dark: "",
                                  "item-text": "label",
                                  "item-value": "value",
                                },
                                model: {
                                  value: _vm.selectedInactiveTime,
                                  callback: function ($$v) {
                                    _vm.selectedInactiveTime = $$v
                                  },
                                  expression: "selectedInactiveTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 setting_btn",
                  attrs: { id: "setting_btn7", cols: "12" },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0 pa-0 back_clean_btn",
                      attrs: {
                        id: "back_clean_btn3",
                        width: "100%",
                        height: "auto",
                        elevation: "0",
                      },
                      on: { click: _vm.goNotificationSetting },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-4",
                          attrs: { align: "center", justify: "space-between" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s(_vm.ts("notificationSetting")))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c("v-img", {
                                staticClass: "ma-0 pa-0 ml-2 pr-2",
                                attrs: {
                                  height: "1rem",
                                  width: "0.6rem",
                                  src: require("@/assets/images/right_btn.png"),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.canAiCameraSetting
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 setting_btn",
                      attrs: { id: "setting_btn7", cols: "12" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0 back_clean_btn",
                          attrs: {
                            id: "back_clean_btn3",
                            width: "100%",
                            height: "auto",
                            elevation: "0",
                          },
                          on: { click: _vm.goInternalCustomerAnalysisSetting },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-4",
                              attrs: {
                                align: "center",
                                justify: "space-between",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.ts("internalCustomerAnalysisSetting")
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c("v-img", {
                                    staticClass: "ma-0 pa-0 ml-2 pr-2",
                                    attrs: {
                                      height: "1rem",
                                      width: "0.6rem",
                                      src: require("@/assets/images/right_btn.png"),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.role == "main" || _vm.role == "head"
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 setting_btn",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 back_clean_btn",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-4",
                              attrs: {
                                align: "center",
                                justify: "space-between",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.ts("cityDisplayWhenSearch"))
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 mr-5",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.cityDisplayValue
                                                  ? _vm.ts("enabled")
                                                  : _vm.ts("invalid")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("v-switch", {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { "hide-details": "" },
                                        model: {
                                          value: _vm.cityDisplayValue,
                                          callback: function ($$v) {
                                            _vm.cityDisplayValue = $$v
                                          },
                                          expression: "cityDisplayValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.authorities.SET_STORE_CONFIG && _vm.uasCount > 0
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 setting_btn",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 back_clean_btn",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-4",
                              attrs: {
                                align: "center",
                                justify: "space-between",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [_vm._v(_vm._s(_vm.ts("anonymousDisplay")))]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 mr-5",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.anonymousDisplayEnable
                                                  ? _vm.t("express")
                                                  : _vm.t("nonRepresentation")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("v-switch", {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { "hide-details": "" },
                                        model: {
                                          value: _vm.anonymousDisplayEnable,
                                          callback: function ($$v) {
                                            _vm.anonymousDisplayEnable = $$v
                                          },
                                          expression: "anonymousDisplayEnable",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 setting_btn",
                  attrs: { id: "setting_btn10", cols: "12" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 back_clean_btn",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-4",
                          attrs: { align: "center", justify: "space-between" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s(_vm.ts("version")))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(" " + _vm._s(_vm.version) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }